import { combineReducers } from 'redux';
import navigationShellSlice from './NavigationShell.slice';
import footerSlice from './Footer/Footer.slice';

const navigationShellReducer = combineReducers({
  navigationShell: navigationShellSlice,
  footer: footerSlice,
});

export default navigationShellReducer;
